/**
 * Copies text to clipboard with proper error handling.
 * Silently ignores failures as clipboard requires secure context and user permission.
 */
export function copyToClipboard(text: string): void {
  if (!navigator.clipboard?.writeText) {
    return;
  }
  Promise.resolve(navigator.clipboard.writeText(text)).catch(() => {
    // Clipboard requires a secure context and user permission; silently
    // ignore failures — copying is a non-critical convenience.
  });
}
